module.exports = __webpack_public_path__ + "img/horizontal_4_3_9016.47c4f93d.png";